<template>
  <div class="modal fade" tabindex="-1" role="dialog" id="subscription-sales-breakdown-modal">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <form @submit.prevent="submit">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">
                                &times;
                            </span>
            </button>

            <h4 class="modal-title">
              Subscription Breakdown
            </h4>
          </div>

          <loading-spinner v-if="loading"/>

          <div v-else class="modal-body">
            <table class="table table-striped">
              <thead>
              <tr>
                <th class="col-xs-5">
                  Company
                </th>

                <th class="col-xs-3">
                  Subscription
                </th>

                <th class="col-xs-4">
                  Price
                </th>
              </tr>
              </thead>

              <tbody>
              <tr v-for="row in rows">
                <td class="table__ellipsis">
                  <router-link :to="'/companies/' + row.company_id" @click.native="hide">
                    {{ row.company_name }}
                  </router-link>
                </td>

                <td class="table__ellipsis">
                  <router-link :to="'/companies/' + row.company_id + '/subscriptions/' + row.subscription_id"
                               @click.native="hide">
                    #{{ row.subscription_id }}
                  </router-link>
                </td>

                <td class="table__ellipsis">
                  {{ row.first_partnership_period_value | price }}
                </td>
              </tr>
              </tbody>

              <tfoot>
              <tr>
                <td colspan="2" class="text-right">
                  <b>
                    Total
                  </b>
                </td>

                <td>
                  <b>
                    {{ total | price }}
                  </b>
                </td>
              </tr>
              </tfoot>
            </table>

            <simple-pager :current-page="page" :last-page="lastPage" @navigate="page = $event"/>
          </div>

          <div class="modal-footer">
            <button type="button" class="btn btn-default" data-dismiss="modal">
              Close
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import http from '@/http'
import LoadingSpinner from '@/components/Layout/LoadingSpinner'
import ResourcePager from '@/components/Utilities/Pagination/ResourcePager'
import SimplePager from "../../../Lists/SimplePager";

export default {
  components: {SimplePager, ResourcePager, LoadingSpinner},

  props: {
    from: {
      required: true
    },

    to: {
      required: true
    },

    users: {
      required: false
    },

    portals: {
      required: false
    },

    company: {
      required: false
    }
  },

  data() {
    return {
      data: null,

      page: 1,
      loading: true
    }
  },

  mounted() {
    this.listenForClose()

    this.load()
  },

  watch: {
    to() {
      this.load()
    },

    from() {
      this.load()
    },

    users() {
      this.load()
    },

    portals() {
      this.load()
    },

    company() {
      this.load()
    }
  },

  computed: {
    rows() {
      return this.data.slice((this.page - 1) * 10, this.page * 10)
    },

    lastPage() {
      return Math.ceil(this.data.length / 10)
    },

    total() {
      return Math.round(this.data.reduce((total, row) => parseFloat(row.first_partnership_period_value) + total, 0))
    },

    filters() {
      let filters = [
        {dimension: 'sold_date', operator: '>=', value: this.from},
        {dimension: 'sold_date', operator: '<=', value: this.to}
      ]

      if ((this.users || []).length) {
        filters.push({dimension: 'user_id', operator: 'in', value: this.users})
      }

      if ((this.portals || []).length) {
        filters.push({dimension: 'portal_id', operator: 'in', value: this.portals})
      }

      if (this.company) {
        filters.push({dimension: 'company_id', value: this.company})
      }

      return filters
    }
  },

  methods: {
    load() {
      this.loading = true

      http.post('/api/v1/reports/new-analytics', {
        metrics: [
          {name: 'first_partnership_period_value'}
        ],
        dimensions: [
          {name: 'subscription_period_id'},
          {name: 'company_id'},
          {name: 'company_name'},
          {name: 'subscription_id'}
        ],
        filters: this.filters
      }).then(response => {
        this.data = response.data.data

        this.data.sort((a,b) => a.company_name > b.company_name ? -1 : 1)

        this.loading = false
      })
    },

    hide() {
      $(this.$el).modal('hide')
    },

    listenForClose() {
      $(this.$el).on('hidden.bs.modal', this.reset)
    },

    reset() {
      this.page = 1
    }
  }
}
</script>
